import { Component } from '@angular/core';
import { NeighborhoodService } from '../../../../services/neighborhood.service';

@Component({
  selector: 'app-settings-modules-page',
  templateUrl: './settings-modules-page.component.html',
  styleUrl: './settings-modules-page.component.scss'
})
export class SettingsModulesPageComponent {

  constructor(
    public neighborhoodService: NeighborhoodService
  ) {}

  update() {
    this.neighborhoodService.update();
  }

}
